import { Integration, SDK } from '@commercetools/frontend-sdk';
import { getProjectActions, ProjectActions } from './actions/ProjectActions';
import { getProductActions, ProductActions } from './actions/ProductActions';
import { getCartActions, CartActions } from './actions/CartActions';
import { getWishlistActions, WishlistActions } from './actions/WishlistActions';
import { AccountActions, getAccountActions } from './actions/AccountActions';
import { StockActions, getStockActions } from './actions/StockActions';
import { CTStockActions, getCTStockActions } from './actions/CTStockActions';
import { AmazonActions, getAmazonData } from './actions/AmazonActions';
import { ComposableCommerceEvents } from '../types/events/ComposableCommerceEvents';

class ComposableCommerce extends Integration<ComposableCommerceEvents> {
  constructor(sdk: SDK<ComposableCommerceEvents>) {
    super(sdk);

    this.project = getProjectActions(sdk);
    this.product = getProductActions(sdk);
    this.cart = getCartActions(sdk);
    this.wishlist = getWishlistActions(sdk);
    this.account = getAccountActions(sdk);
    this.stock = getStockActions(sdk);
    this.amazon = getAmazonData(sdk);
    this.ctstock = getCTStockActions(sdk);
  }

  unregisterExtension(): void {}

  project: ProjectActions;
  product: ProductActions;
  cart: CartActions;
  wishlist: WishlistActions;
  account: AccountActions;
  stock: StockActions;
  ctstock: CTStockActions;
  amazon: AmazonActions;
}

export { ComposableCommerce };
